<template>
  <div data-burger-test-id class="burger" :class="{ open: isOpen, landing }" @click="toggle">
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  props: {
    landing: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const store = useStore();
    const isOpen = computed(() => store.getters['burgerMenu/isOpen']);

    const toggle = () => {
      store.dispatch('burgerMenu/setBurger', { isOpen: !isOpen.value });
    };

    return {
      isOpen,
      toggle,
    };
  },
});
</script>
<style scoped lang="scss">
.burger {
  position: relative;
  width: 30px;
  height: 24px;
  cursor: pointer;
}

.burger span {
  position: absolute;
  left: 0;
  width: 100%;
  height: 4px;
  background: #fff;
  border-radius: 2px;
  transition: 0.3s;
}

.burger span:nth-child(1) {
  top: 0;
}
.burger span:nth-child(2) {
  top: 10px;
}
.burger span:nth-child(3) {
  top: 20px;
}

.burger.open span:nth-child(1) {
  transform: rotate(45deg);
  top: 10px;
}
.burger.open span:nth-child(2) {
  opacity: 0;
}
.burger.open span:nth-child(3) {
  transform: rotate(-45deg);
  top: 10px;
}

.burger.landing {
  width: 22px;
  height: 16px;
}

.burger.landing span {
  height: 1.5px;
  background: #f6f3ee;
  border-radius: 999px;
}

.burger.landing span:nth-child(1) {
  top: 0;
}
.burger.landing span:nth-child(2) {
  top: 7px;
}
.burger.landing span:nth-child(3) {
  top: 14px;
}

.burger.landing.open span:nth-child(1),
.burger.landing.open span:nth-child(3) {
  top: 7px;
}
</style>
